// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchUsers, fetchRecipients, fetchClients } from '../../actions/admin'

type Props = {
  children?: any,
  fetchUsers: Function,
  fetchClients: Function,
  fetchRecipients: Function
}

class Admin extends Component {
  componentDidMount() {
    this.props.fetchUsers()
    this.props.fetchClients()
    this.props.fetchRecipients()
  }

  props: Props

  render() {
    return <div>{this.props.children}</div>
  }
}

export default connect(
  (state) => ({
    users: state.admin.users
  }),
  {
    fetchUsers,
    fetchClients,
    fetchRecipients
  }
)(Admin)



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js